$(function () {
    const s3Url = window.APP_S3_URL;
    // collapse toggle icons
    $('.collapse').each(function () {
        var toggle = $('a[href="#' + this.id + '"]').find('.toggle-icon');
        toggle.html($(this).hasClass('show') ? '<i class="fas fa-minus"></i>' : '<i class="fas fa-plus"></i>');
    });
    $('.collapse').on('show.bs.collapse', function () {
        $('a[href="#' + this.id + '"]').find('.toggle-icon').html('<i class="fas fa-minus"></i>');
    });
    $('.collapse').on('hide.bs.collapse', function () {
        $('a[href="#' + this.id + '"]').find('.toggle-icon').html('<i class="fas fa-plus"></i>');
    });

    firstLoad();

    // refined tags
    function toggleRefinedLabel() {
        if ($('.refined-tags .badge').length > 0) {
            $('.refined-label').removeClass('d-none');
        } else {
            $('.refined-label').addClass('d-none');
        }
    }

    function showSkeleton(forceToFirstPage = false) {
        const skeletonHtml = `
            <div class="map-result d-flex mb-3">
                <div class="skeleton" style="width:180px;height:180px;margin-right:1rem;"></div>
                <div style="flex:1;">
                    <div class="skeleton mb-2" style="height:20px;width:60%;"></div>
                    <div class="skeleton mb-2" style="height:14px;width:30%;"></div>
                    <div class="skeleton mb-5" style="height:14px;width:10%;"></div>
                    <div class="skeleton mb-2" style="height:14px;width:80%;"></div>
                    <div class="skeleton mb-2" style="height:14px;width:60%;"></div>
                    <div class="skeleton mb-0 mt-2" style="height:20px;width:20%;"></div>
                </div>
            </div>`;
        $('#results-container').html(skeletonHtml + skeletonHtml + skeletonHtml);
        setTimeout(function(){loadResults(forceToFirstPage)}, 1000);
    }

    $(document).on('click', '.load-more-category', function () {
        const category_id = $(this).data('category-id');
        loadMoreCategories(category_id);
    });

    function loadMoreCategories(category_id) {
        const base_url = '/categories/loadMore';
        const _token = $("meta[name='csrf-token']").attr('content');
        $.ajax({
            url: base_url,
            type: "POST",
            data: {
                _token: _token,
                category_id: category_id,
            },
            success: function (data) {
                if (data.success) {
                    const params = new URLSearchParams(window.location.search);
                    let qArray = params.get('q') ? params.get('q').split(',') : [];
                    let mainCategory = $('#collapse-'+ data.category.slug + ' ul');
                    mainCategory.empty();
                    data.category.children.forEach(function (subCategory) {
                        let result = `
                                            <li>
                                                <a href="#"
                                                    class="d-flex justify-content-between align-items-center py-1 px-2 sidebar-link filter-option"
                                                    data-category="${data.category.name}"
                                                    data-slug="${subCategory.slug}"
                                                    data-value="${subCategory.name}">
                                                    ${subCategory.name}
                                                <span>
                                                    <span class="text-muted">${subCategory.exhibit_count}</span>
                                                    <span class="remove-filter ml-2 d-none" style="cursor:pointer;">&times;</span>
                                                </span>
                                                </a>
                                            </li>`;

                        mainCategory.append(result);

                        if (qArray.includes(subCategory.slug)) {
                            selectCategory($('.filter-option[data-slug="' + subCategory.slug + '"]'));
                        }
                    });

                    mainCategory.append(`<button class="text-primary load-less-category" type="button" data-category-id="${data.category.id}" data-category-slug="${data.category.slug}" data-sub-limit="${data.category.sub_limit}" style="border:0;background: none">Load Less...</button>`);
                } else {
                    alert("Error in load categories");
                }
            },
            error: function () {
                alert("Something went wrong");
            }
        });
    }

    $(document).on('click', '.load-less-category', function () {
        const category_id = $(this).data('category-id');
        const category_slug = $(this).data('category-slug');
        const categorySubLimit = $(this).data('sub-limit');
        const mainCategory = $('#collapse-'+ category_slug + ' ul');
        mainCategory.find('li').slice(categorySubLimit).remove();
        mainCategory.append(`<button class="text-primary load-more-category" type="button" data-category-id="${category_id}" data-sub-limit="${categorySubLimit}" style="border:0;background: none">Load More...</button>`);
        $(this).remove();
    });

    document.querySelectorAll('input[name="filter_by"]').forEach(radio => {
        radio.addEventListener('change', function () {
            const filterBy = this.value;
            const urlParams = new URLSearchParams(window.location.search);
            const defaultFilter = urlParams.get('filterBy')
            if (filterBy == defaultFilter) return;
            urlParams.set('filterBy', filterBy);
            window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
            showSkeleton(); // trigger loading
        });
    });

    function loadResults(forceToFirstPage = false) {
        const _token = $("meta[name='csrf-token']").attr('content');
        const base_url = '/categories/filter';
        const s3BaseUrl = s3Url;
        const urlParams = new URLSearchParams(window.location.search);
        const query = urlParams.get('q') ?? '';
        const sortBy = urlParams.get('sortBy') ?? 'view-desc';
        const filterBy = urlParams.get('filterBy') ?? 'intersection';
        const search = urlParams.get('search') ? urlParams.get('search') : '';
        const perPage = $('.per-page').val();
        const page = (urlParams.get('page') && forceToFirstPage == false) ? urlParams.get('page') : 1;
        urlParams.set('page', page);
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

        $.ajax({
            url: base_url,
            type: "POST",
            data: {
                _token: _token,
                filter: query,
                page: page,
                sortBy: sortBy,
                filterBy: filterBy,
                search: search,
                perPage: perPage,
            },
            success: function (data) {
                if (data.success) {
                    $('#results-container').empty();
                    if (data.exhibits.total == 0) {
                        const noResultError = `<div class="alert alert-warning border-warning">No results were found for your current filters. Please change or remove them by clicking here: <a href="/categories" class="btn btn-dark btn-sm" type="button">Remove filters</a></div>`;
                        $('#results-container').append(noResultError);
                        $('.result-count').html(`Results: ${data.exhibits.from ?? 0}–${data.exhibits.to ?? 0} of ${data.exhibits.total}`);
                        renderPagination(data.exhibits)
                        return;
                    }
                    data.exhibits.data.forEach(function (exhibit) {
                        const thumbnail = exhibit.first_image_thumbnail;

                        const lastModifiedAt = new Date(exhibit.updated_at)
                            .toISOString()
                            .slice(0, 16)
                            .replace('T', ' ');

                        const curators = (exhibit.curator).map(item => item?.name).filter(Boolean).join(', ');

                        let result = `
                                            <div class="map-result mb-3">
                                                <a target="_blank" href="/exhibits/${exhibit.id}"><img src="${thumbnail}" loading="lazy" alt="${exhibit.title}"/></a>
                                                <div class="right-side">
                                                    <div class="main-content">
                                                        <h5 class="title"><a target="_blank" href="/exhibits/${exhibit.id}">${exhibit.title}</a></h5>
                                                        <div class="meta">
                                                            <span><strong>Curators:</strong> ${curators ? curators.slice(0, 60) + (curators.length > 60 ? '...' : '') : '-'}</span> | <span><strong>Exhibit ID:</strong> ${exhibit.id}</span> | <strong>Last Modified At:</strong> ${lastModifiedAt}
                                                        </div>
                                                        <p class="desc mb-1 mt-1">${$('<div>').html(exhibit.description).text().slice(0, 350) + (exhibit.description.length > 350 ? '...' : '')}</p>
                                                        <div class="exhInfoMobile d-flex justify-content-start w-sm-50">
<!--                                                        TODO: Remove Like and Comments-->
<!--                                                            <p class="text-blue mr-2 mb-0"><i class="fa fa-heart mr-1 text-blue" aria-hidden="true"></i>${exhibit.total_likes}</p>-->
<!--                                                            <p class="text-blue mr-2 mb-0"><i class="fa fa-comment mr-1 text-blue" aria-hidden="true"></i>${exhibit.total_comments}</p>-->
                                                            <p class="text-blue mr-2 mb-0"><i class="fas fa-images mr-1 text-blue" aria-hidden="true"></i>${exhibit.image_count}</p>
                                                            <p class="text-blue mr-2 mb-0"><i class="fas fa-map-pin mr-1 text-blue" aria-hidden="true"></i>${exhibit.images_dots_count}</p>
                                                            <p class="text-blue mr-2 mb-0"><i class="fas fa-volume-up mr-1 text-blue" aria-hidden="true"></i>${exhibit.total_voices}</p>
                                                            <p class="text-blue mr-2 mb-0"><i class="fas fa-eye mr-1 text-blue" aria-hidden="true"></i>${exhibit.views.total}</p>
                                                            <p class="text-blue mb-0 category-popover-wrapper d-inline-block"><i class="fa fa-archive pointer category-popover ${exhibit.category_detected ? 'category-detected' : ''}"
                                                               data-url="/exhibit/categories/${exhibit.id}"
                                                               aria-hidden="true"></i>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>`;

                        $('#results-container').append(result);
                    });

                    if (window.innerWidth < 768) {
                        document.querySelectorAll('.meta').forEach(el => {
                            el.innerHTML = el.innerHTML.replace(/\s*\|\s*/g, '');
                        });
                        $('.meta span').addClass('mb-2');
                    }

                    $('.result-count').html(`Results: ${data.exhibits.from ?? 0}–${data.exhibits.to ?? 0} of ${data.exhibits.total}`);
                    renderPagination(data.exhibits)
                } else {
                    alert("Error in load items");
                }
            },
            error: function () {
                alert("Something went wrong");
            }
        });
    }

    function firstLoad() {
        const params = new URLSearchParams(window.location.search);
        const sortBy = params.get('sortBy') ? params.get('sortBy') : 'view-desc';
        const filterBy = params.get('filterBy') ? params.get('filterBy') : 'intersection';
        const search = params.get('search') ? params.get('search') : '';
        const query = params.get('q') ? params.get('q') : '';

        $('.sort-by').val(sortBy).change();
        if (sortBy !== 'view-desc') {
            $('.sort-cancel').removeClass('d-none');
        }

        $('.search').val(search);
        if (search) {
            $('.search-cancel').removeClass('d-none');
        }

        if (query) {
            if (window.innerWidth < 768) {
                toggleAllCategories();
            }
        }

        $(`input[name="filter_by"][value="${filterBy}"]`).prop('checked', true).trigger('change');

        showSkeleton(); // trigger loading
    }

    function selectCategory(sidebarElement) {
        let category = sidebarElement.data('category');
        let slug = sidebarElement.data('slug');
        let value = sidebarElement.data('value');
        let tagId = category + '-' + value;

        if ($('.refined-tags [data-category-id="' + tagId + '"]').length === 0) {
            $('.refined-tags').append(
                `<span class="badge badge-primary text-white ml-1" data-slug="${slug}" data-category-id="${tagId}">
                        ${category}: ${value}
                        <span class="ml-1 remove-tag" style="cursor:pointer;">&times;</span>
                        </span>`
            );
            toggleRefinedLabel();
            addFilterParameterToUrl(slug);
        }
        sidebarElement.find('.remove-filter').removeClass('d-none');
    }

    // Sort result
    $(document).on('click', '.sort-submit', function () {
        const sortBy = $('.sort-by').val();

        const urlParams = new URLSearchParams(window.location.search);
        const defaultSort = urlParams.get('sortBy')
        if (sortBy == defaultSort) return;
        urlParams.set('sortBy', sortBy);
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

        $('.sort-cancel').removeClass('d-none');

        showSkeleton(true); // trigger loading
    });

    // Sort cancel
    $(document).on('click', '.sort-cancel', function () {
        $('.sort-by').val('view-desc').change();

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('sortBy');
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

        $('.sort-cancel').addClass('d-none');

        showSkeleton(true); // trigger loading
    });

    // Search result
    $(document).on('click', '.search-submit', function () {
        const search = $('.search').val();

        const urlParams = new URLSearchParams(window.location.search);
        const defaultSearch = urlParams.get('search')
        if (!search || search == defaultSearch) return;
        urlParams.set('search', search);
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

        $('.search-cancel').removeClass('d-none');

        showSkeleton(true); // trigger loading
    });

    // Search cancel
    $(document).on('click', '.search-cancel', function () {
        $('.search').val('');

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('search');
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

        $('.search-cancel').addClass('d-none');

        showSkeleton(true); // trigger loading
    });

    // Results per page
    $(document).on('change', '.per-page', function () {
        showSkeleton(true); // trigger loading
    });

    // Add tag
    $(document).on('click', '.filter-option', function (e) {
        if ($(this).find('span span').hasClass('remove-filter') && !$(this).find('span span').hasClass('d-none')) {
            $(this).find('span .remove-filter').trigger('click');
            return;
        }

        selectCategory($(this))
        showSkeleton(true); // trigger loading
    });

    // Remove tag from top
    $(document).on('click', '.remove-tag, .badge', function () {
        let badge = $(this).closest('.badge');
        let slug = badge.data('slug');
        let tagId = badge.data('category-id');
        badge.remove();

        $('.filter-option').each(function () {
            if ($(this).data('category') + '-' + $(this).data('value') === tagId) {
                $(this).find('.remove-filter').addClass('d-none');
            }
        });

        toggleRefinedLabel();
        removeFilterParameterFromUrl(slug)
        showSkeleton(true); // trigger loading
    });

    // Remove tag from sidebar
    $(document).on('click', '.remove-filter', function (e) {
        e.stopPropagation();
        let parent = $(this).closest('.filter-option');
        let slug = parent.data('slug');
        let tagId = parent.data('category') + '-' + parent.data('value');

        $('.refined-tags [data-category-id="' + tagId + '"]').remove();
        $(this).addClass('d-none');
        toggleRefinedLabel();
        removeFilterParameterFromUrl(slug)
        showSkeleton(true); // trigger loading
    });

    function addFilterParameterToUrl(slug) {
        const params = new URLSearchParams(window.location.search);
        let qArray = params.get('q') ? params.get('q').split(',') : [];
        const newValue = slug;

        if (!qArray.includes(newValue)) qArray.push(newValue);
        params.set('q', qArray.join(','));

        window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
    }

    function removeFilterParameterFromUrl(slug) {
        const params = new URLSearchParams(window.location.search);
        let qArray = params.get('q') ? params.get('q').split(',') : [];

        qArray = qArray.filter(v => v !== slug);
        params.set('q', qArray.join(','));

        window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
    }

    function renderPagination(data) {
        if (data.total === 0) {
            $('#pagination-links').empty();
            return
        }
        let html = '<ul class="pagination mb-0">';

        const current = data.current_page;
        const last = data.last_page;

        // Previous
        html += current > 1
            ? `<li class="page-item"><a href="#" class="page-link" data-page="${current - 1}">&laquo;</a></li>`
            : `<li class="page-item disabled"><span class="page-link">&laquo;</span></li>`;

        // Range control
        const start = Math.max(1, current - 2);
        const end = Math.min(last, current + 2);

        // First page
        if (start > 1) {
            html += `<li class="page-item"><a href="#" class="page-link" data-page="1">1</a></li>`;
            if (start > 2) html += `<li class="page-item disabled"><span class="page-link">...</span></li>`;
        }

        // Middle range
        for (let i = start; i <= end; i++) {
            html += `<li class="page-item ${i === current ? 'active' : ''}">
                    <a href="#" class="page-link" data-page="${i}">${i}</a>
                 </li>`;
        }

        // Last page
        if (end < last) {
            if (end < last - 1) html += `<li class="page-item disabled"><span class="page-link">...</span></li>`;
            html += `<li class="page-item"><a href="#" class="page-link" data-page="${last}">${last}</a></li>`;
        }

        // Next
        html += current < last
            ? `<li class="page-item"><a href="#" class="page-link" data-page="${current + 1}">&raquo;</a></li>`
            : `<li class="page-item disabled"><span class="page-link">&raquo;</span></li>`;

        html += '</ul>';

        $('#pagination-links').html(html);
    }

    $(document).on('click', '#pagination-links .page-link', function (e) {
        e.preventDefault();
        let page = $(this).data('page');
        const params = new URLSearchParams(window.location.search);
        params.set('page', page);
        window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
        if (page && !$(this).parent('li').hasClass('active')) showSkeleton();
    });

    $(document).on('click', '.toggle-all', function () {
        toggleAllCategories();
    });

    function toggleAllCategories() {
        const mainToggleButton = $('.toggle-all');
        if (mainToggleButton.hasClass('close')) {
            $('[id^="collapse-"]').collapse('show');
            mainToggleButton.removeClass('close').addClass('open').html('<i class="fas fa-minus"></i>');
        } else if (mainToggleButton.hasClass('open')) {
            $('[id^="collapse-"]').collapse('hide');
            mainToggleButton.removeClass('open').addClass('close').html('<i class="fas fa-plus"></i>');
        }
    }

    $(document).on('click', '.category-popover', function (e) {
        e.stopPropagation();

        const el = $(this);

        $('.category-popover').not(el).each(function () {
            const other = $(this);
            if (other.data('bs.popover')) {
                other.popover('hide');
            }
        });

        // If already initialized → toggle
        if (el.data('bs.popover')) {
            el.popover('toggle');
            return;
        }

        // First click → load content
        $.get(el.data('url'), function (html) {
            el.popover({
                content: html,
                html: true,
                trigger: 'manual',
                placement: 'auto',
                container: el.closest('.category-popover')[0],
                boundary: 'viewport'
            });

            el.popover('show');

            el.on('shown.bs.popover', function () {
                const popper = el.data('bs.popover').popper;
                if (popper) {
                    popper.scheduleUpdate();
                }
            });
        });
    });

    // Close when clicking outside
    $(document).on('click', function () {
        $('.category-popover').each(function () {
            const el = $(this);
            if (el.data('bs.popover')) {
                el.popover('hide');
            }
        });
    });
});
